import { createFileRoute } from '@tanstack/react-router';

import { ensureRouteAccess } from '@/lib/auth/guards';

export const Route = createFileRoute('/(authenticated)/patients/')({
	beforeLoad: ensureRouteAccess('/patients'),
	head: () => ({
		meta: [
			{
				title: 'Alopex Health | Patients',
			},
		],
	}),
});
